import { routerNavRequest, userInfoRequest } from '@/api/request'
import { getAccessToken, getUserInfo, hasRouterPermission } from '@/auth'
import { genBackendRouter } from '@tellus/router'
import modules from './modules'
import { genFrontendRouters } from './utils'

// ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
// ルート権限検証 MFA 完了チェックの追加
function hasFullPermission() {
  // トークンがあるかどうかを確認する
  const hasToken = getAccessToken()
  if (!hasToken) {
    return false
  }

  // MFAが完了しているか確認する
  return sessionStorage.getItem('mfaCompleted') === 'true'
}
// ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

export const routerAuthConfig = {
  loginPath: '/login',
  errorPath: '/error',
  homePath: '/home',
  // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
  // ルート権限検証 MFA 完了チェックの追加
  // hasPermission: getAccessToken,
  hasPermission: hasFullPermission,
  // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
  getAccessRoutes: getPermissionRouters
}

const isFront = true

// used in layout to show in the siderbar menu
export let permissionRouters = []

/**
 * generate routes by user permission
 *
 * @returns permissionRouters
 */
export async function getPermissionRouters() {
  // get user info
  let userInfo = getUserInfo()
  if (!userInfo) {
    userInfo = await userInfoRequest()
  }

  // get permission list
  const permissionList = [].concat(
    userInfo.Roles.map(role => role.RoleId),
    userInfo.Auths.map(auth => auth.AuthId)
  )
  // generate permission route list
  if (isFront) {
    permissionRouters = genFrontendRouters(modules, router => hasRouterPermission(router, permissionList))
  } else {
    const backendRouterList = await routerNavRequest()
    permissionRouters = genBackendRouter(backendRouterList.children)
  }

  return permissionRouters
}
